import { fireEvent } from '#src/common/lib/events'
import { useEffect } from 'react'
import { TRANSACTIONAL_PRODUCT_DETAILS } from '#src/common/lib/events/topics'

export const useGtmEvent = ({ isTransactional, product, categories }) => {
  useEffect(() => {
    if (isTransactional && product) {
      fireEvent(TRANSACTIONAL_PRODUCT_DETAILS, { product, categories })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTransactional, product])
}
